module.exports = __webpack_public_path__ + "static/media/leo_liu.dd7c9fb3.png";